import type { CoursesAdminCreateAppTagDto } from '@sportspredict/shared';
import type { Wire } from '../../types/common.types';
import { coursesApi } from './courses-base.api';
import type {
	ListAppTagDefsOutput,
	AdminCreateAppTagInput,
	AdminCreateAppTagOutput,
	AdminDeleteAppTagInput,
	AdminDeleteAppTagOutput,
} from '../../types/app-tags.types';

const TAG = 'courses:app-tags' as const;
const INVALIDATES = [TAG, 'courses:courses'] as const;
const DELETE_INVALIDATES = [
	...INVALIDATES,
	'courses:access-requests',
	'courses:admin',
	'courses:admin-analytics',
	'courses:admin-course-access',
	'courses:admin-courses',
	'courses:admin-emails',
	'courses:admin-user-profile',
	'courses:dashboard',
	'courses:tag-invites',
	'courses:user-tags',
] as const;

export const appTagsEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		listAppTagDefs: builder.query<ListAppTagDefsOutput, void>({
			query: () => ({ url: 'courses/tags/defs' }),
			providesTags: [TAG],
		}),
		adminCreateAppTag: builder.mutation<AdminCreateAppTagOutput, AdminCreateAppTagInput>({
			query: (body) => ({
				url: 'courses/admin/platform/app-tags',
				method: 'POST',
				body: body satisfies Wire<CoursesAdminCreateAppTagDto>,
			}),
			invalidatesTags: [...INVALIDATES],
		}),
		adminDeleteAppTag: builder.mutation<AdminDeleteAppTagOutput, AdminDeleteAppTagInput>({
			query: ({ key }) => ({
				url: `courses/admin/platform/app-tags/${encodeURIComponent(key)}`,
				method: 'DELETE',
			}),
			invalidatesTags: [...DELETE_INVALIDATES],
		}),
	}),
});

export const {
	useListAppTagDefsQuery,
	useAdminCreateAppTagMutation,
	useAdminDeleteAppTagMutation,
} = appTagsEndpoints;
